"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var colors_1 = require("../../themes/main/colors");
exports.default = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        title: {
            fontSize: '12px',
            textTransform: 'uppercase',
            margin: "8px 0",
            color: colors_1.materialColors.grey[500],
        },
        content: {
            lineHeight: '20px',
            wordBreak: 'break-word',
        },
    });
});
